<template>
	<div class="sContent">
		<div class="sTitle">
			<div class="label">长三角G60科创集团首发园区</div>
			<div class="titleCenter">
				<img src="./assets/topBg.png" class="img" alt="" srcset="" />
				<span>{{$route.name}}</span>
			</div>
			<div class="time">{{time}}</div>
		</div>
		<div class="content">
			<router-view />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'app',
		data() {
			let href = window.location.href.split('/');
			return {
				time: ''
			}
		},
		created: function() {
			console.log(this.$route)
			this.getTime();
		},
		methods: {
			getTime() {
				this.time = this.setDate({});
				setTimeout(_ => {
					this.getTime()
				}, 1000)
			},
			setDate({
				time = new Date().getTime(),
				type = 'YYYY/MM/DD hh:mm:ss'
			}) {
				function add0(num) {
					return Number(num) > 9 ? Number(num) + '' : '0' + Number(num);
				}

				let date = new Date(time);
				return type.replace('YYYY', date.getFullYear()).replace('MM', add0(date.getMonth() + 1)).replace('DD',
						add0(
							date
							.getDate())).replace('hh', add0(date.getHours())).replace('mm', add0(date.getMinutes()))
					.replace(
						'ss',
						add0(date.getSeconds()))
			},
		}
	}
</script>
<style>
	@media (max-width: 1980) {
		html{
			font-size: 10px;
		}
	}
	@media (min-width: 1981) {
		html{
			font-size: 20px;
		}
	}
</style>
<style lang="scss" scoped>
	@font-face {
		font-family: 'Ali';
		src: url('assets/font/ali.ttf') format('truetype');
		font-weight: normal;
		font-style: normal;
	}
	* {
		margin: 0;
		padding: 0;
		color: #FFF;
		font-family: 'Ali';
		user-select: none;
		-webkit-user-drag: none;
		/* Chrome, Opera, Safari */
		-khtml-user-drag: none;
		/* Konqueror */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* Internet Explorer/Edge */
	}
	
	img{
		user-select: none;
		-webkit-user-drag: none;
		/* Chrome, Opera, Safari */
		-khtml-user-drag: none;
		/* Konqueror */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* Internet Explorer/Edge */
	}
	div {
		line-height: 1.8;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		flex-direction: column;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	html{
		font-size: 2vw !important;
	}

	.sContent {
		background: #092234;
		width: 100%;
		min-width: 1440px;
		max-width: 100%;
		height: 100vh;
		max-height: 100vh;
		font-size: 12px;
		line-height: 1.8;
		/* #ifndef APP */
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		/* #endif */
		display: flex;
		flex-direction: column;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		>.content{
			z-index: 999;
			flex: 1;
		}
	}

	.sTitle {
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		background: #060D1F;
		height: 98px;
		color: #FFF;
		padding: 0 18px 0 28px;
		z-index: 9;
		.label {
			width: 1px;
			white-space: nowrap;
			font-size: 28px;
			padding-top: 30px;
			line-height: 30px;
      font-weight: bold;
		}
		
		.time {
			font-size: 18px;
			padding-top: 24px;
			line-height: 14px;
			white-space: nowrap !important;
			width: 1px;
			text-align: right;
			align-items: flex-end;
		}
		
		.titleCenter {
			width: 284px;
			height: 170px;
			justify-content: center;
			align-items: center;
			position: relative;
			user-select: none;
			-webkit-user-select: none;
			/* Safari */
			-moz-user-select: none;
			/* Firefox */
			-ms-user-select: none;
			/* IE10+/Edge */
		}
		
		.titleCenter:before {
			content: '';
			display: block;
			position: fixed;
			top: 98px;
			left: 0;
			width: 100vw;
			height: 3px;
			background: linear-gradient(to right, #092234 0%, #848484 30%, #FFF 50%, #848484 70%, #092234 100%);
			box-shadow: 1px 0 4px 0px #292D37;
			z-index: 2;
			opacity: .6;
		}
		@keyframes iconMove {
			0% {
				opacity: 1;
			}
		
			50% {
				opacity: .5;
			}
		
			100% {
				opacity: 1;
			}
		}
		.img {
			width: 284px;
			height: 170px;
			animation: iconMove 2s infinite;
			user-select: none;
			-webkit-user-select: none;
			/* Safari */
			-moz-user-select: none;
			/* Firefox */
			-ms-user-select: none;
			/* IE10+/Edge */
		}
	
		
		.titleCenter span {
			font-size: 31px;
			color: #FFFFFF;
			line-height: 14px;
			position: absolute;
			top: 40px;
			line-height: 60px;
			text-shadow:
				0 0 30px #3388FF,
				0 0 30px #3388FF,
				0 0 30px #3388FF,
				0 0 30px #3388FF;
		}
	}
	
	

</style>